<template>
  <div id="app">
    <van-number-keyboard safe-area-inset-bottom />
    <van-tabbar v-model="active" @change="onChange">
      <van-tabbar-item icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item icon="apps-o">产品</van-tabbar-item>
      <van-tabbar-item icon="newspaper-o">新闻</van-tabbar-item>
      <van-tabbar-item icon="label-o">关于</van-tabbar-item>
    </van-tabbar>
    <div v-if="active === 0">
      <homePage></homePage>
    </div>
    <div v-if="active === 1">
      <product></product>
    </div>
    <div v-if="active === 2">
      <news></news>
    </div>
    <div v-if="active === 3">
      <about></about>
    </div>
  </div>
</template>

<script>
import homePage from "@/views/homePage.vue";
import product from "@/views/product.vue";
import news from "@/views/news.vue";
import about from "@/views/about.vue";

export default {
  name: 'App',
  components: {
    homePage,
    product,
    news,
    about
  },
  data(){
    return{
      active:0,
    }
  },
  mounted() {
    // (function(){
    //   const html = document.getElementsByTagName('html')[0];  // html节点
    //   let resizeEvent = 'orientationchange' in window ? 'orientationchange' : 'resize';
    //
    //   let setRootFontSize = function() {
    //     let width = html.clientWidth; // 设备宽度
    //     width = width > 768 ? 768 : width // 最大768
    //     width = width < 320 ? 320 : width // 最大320
    //
    //     html.setAttribute('style','font-size:'+(width/10)+'px');
    //   }
    //
    //   setRootFontSize();
    //   if (!document.addEventListener) return;
    //   // 监听设备屏幕旋转/页面resize
    //   window.addEventListener(resizeEvent, setRootFontSize, false);
    //   // 监听刷新页面
    //   document.addEventListener('DOMContentLoaded', setRootFontSize, false);
    // })();
  },
  methods:{
    onChange(index) {
    },
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
